var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "catRatePopupManager",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title:
          _vm.tempRateCategory.id !== undefined
            ? _vm.$l10n.__("Modification d’une catégorie tarifaire")
            : _vm.$l10n.__("Ajout d’une catégorie tarifaire"),
        closeOnClickOverlay: false
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default" },
          [
            _c("div", { staticClass: "mb-3 typographies-heading-h3" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Information catégorie tarifaire")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Nom de la catégorie")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "wp-10",
              on: { input: _vm.onLabelValueChange },
              model: {
                value: _vm.tempRateCategory.label,
                callback: function($$v) {
                  _vm.$set(_vm.tempRateCategory, "label", $$v)
                },
                expression: "tempRateCategory.label"
              }
            }),
            _vm._v(" "),
            _vm.displayErrorOnInputEmpty
              ? _c(
                  "p",
                  {
                    staticClass: "pt-1",
                    attrs: { size: "small", type: "alert" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Ce champ doit être renseigné")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("SwitchWithLabel", {
              staticClass: "mb-3 mt-3",
              attrs: {
                textLabel: _vm.$t.__(
                  "settings.taxes.popup.CatRatePopupManager.document_including_tax"
                ),
                value: _vm.tempRateCategory.includes_taxes
              },
              on: {
                change: function($event) {
                  return _vm.updateIncludesTaxes($event)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("TVA à appliquer")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "mb-3 wp-10",
                attrs: { popperClass: "customDropdownCatRatePopupManager" },
                model: {
                  value: _vm.tempRateCategory.tax_id,
                  callback: function($$v) {
                    _vm.$set(_vm.tempRateCategory, "tax_id", $$v)
                  },
                  expression: "tempRateCategory.tax_id"
                }
              },
              [
                _c("el-option", {
                  attrs: {
                    value: null,
                    label: _vm.$t.__(
                      "settings.taxes.popup.CatRatePopupManager.product_tax"
                    )
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.listNoEcoTaxes, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: _vm._f("taxeLabel")(item), value: item.id }
                  })
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Devise")))
            ]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "mb-3 wp-10",
                attrs: { popperClass: "customDropdownCatRatePopupManager" },
                model: {
                  value: _vm.tempRateCategory.currency,
                  callback: function($$v) {
                    _vm.$set(_vm.tempRateCategory, "currency", $$v)
                  },
                  expression: "tempRateCategory.currency"
                }
              },
              [
                _c("el-option", {
                  attrs: {
                    value: null,
                    label: _vm.$t.__(
                      "settings.taxes.popup.CatRatePopupManager.account_currency"
                    )
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.currencies, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.label }
                  })
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.accountingEnable
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Code compta vente")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectAccountingCode",
                      staticClass: "mb-3 wp-10",
                      attrs: {
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value:
                          _vm.tempRateCategory.accounting.accounting_code_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.accounting,
                            "accounting_code_id",
                            $$v
                          )
                        },
                        expression:
                          "tempRateCategory.accounting.accounting_code_id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.accounting_code"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.accountingCodes, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            label: _vm._f("accountingCodeLabel")(item),
                            value: item.value
                          }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.accountingEnable
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Code compta remises vente")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectAccountingDiscountCode",
                      staticClass: "mb-6 wp-10",
                      attrs: {
                        disabled: !_vm.accountingCodeForDiscount,
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value:
                          _vm.tempRateCategory.accounting
                            .discount_accounting_code_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.accounting,
                            "discount_accounting_code_id",
                            $$v
                          )
                        },
                        expression:
                          "tempRateCategory.accounting.discount_accounting_code_id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.default_accounting_code"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.accountingCodes, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            label: _vm._f("accountingCodeLabel")(item),
                            value: item.value
                          }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3 typographies-heading-h3" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Apparence par défaut")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _vm.layoutCanBeEstimates
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Apparence des devis")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectLayoutEstimate",
                      staticClass: "mb-3 wp-10",
                      attrs: {
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value:
                          _vm.tempRateCategory.default_layouts.estimates.id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.default_layouts.estimates,
                            "id",
                            $$v
                          )
                        },
                        expression:
                          "tempRateCategory.default_layouts.estimates.id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.quote_default_appearance"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documentLayouts, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.layoutCanBeInvoices
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Apparence des factures")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectLayoutInvoice",
                      staticClass: "mb-3 wp-10",
                      attrs: {
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value: _vm.tempRateCategory.default_layouts.invoices.id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.default_layouts.invoices,
                            "id",
                            $$v
                          )
                        },
                        expression:
                          "tempRateCategory.default_layouts.invoices.id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.invoice_default_appearance"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documentLayouts, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.layoutCanBeCreditNotes
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Apparence des avoirs")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectLayoutCreditNote",
                      staticClass: "mb-3 wp-10",
                      attrs: {
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value:
                          _vm.tempRateCategory.default_layouts.credit_notes.id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.default_layouts.credit_notes,
                            "id",
                            $$v
                          )
                        },
                        expression:
                          "tempRateCategory.default_layouts.credit_notes.id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.credit_note_default_appearance"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documentLayouts, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.layoutCanBeDeliveries
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.__("Apparence des bons de livraison")
                        ) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.layoutCanBeDeliveries
                    ? _c(
                        "el-select",
                        {
                          ref: "selectLayoutDelivery",
                          staticClass: "mb-3 wp-10",
                          attrs: {
                            popperClass: "customDropdownCatRatePopupManager"
                          },
                          model: {
                            value:
                              _vm.tempRateCategory.default_layouts.deliveries
                                .id,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.tempRateCategory.default_layouts.deliveries,
                                "id",
                                $$v
                              )
                            },
                            expression:
                              "tempRateCategory.default_layouts.deliveries.id"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              value: null,
                              label: _vm.$t.__(
                                "settings.taxes.popup.CatRatePopupManager.delivery_note_default_appearance"
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.documentLayouts, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.layoutCanBeOrders
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Apparence des bons de commande")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectLayoutOrder",
                      staticClass: "mb-3 wp-10",
                      attrs: {
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value: _vm.tempRateCategory.default_layouts.orders.id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.default_layouts.orders,
                            "id",
                            $$v
                          )
                        },
                        expression: "tempRateCategory.default_layouts.orders.id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.order_default_appearance"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documentLayouts, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.layoutCanBeProformas
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Apparence des proformas")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectLayoutProforma",
                      staticClass: "mb-3 wp-10",
                      attrs: {
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value:
                          _vm.tempRateCategory.default_layouts.proformas.id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.default_layouts.proformas,
                            "id",
                            $$v
                          )
                        },
                        expression:
                          "tempRateCategory.default_layouts.proformas.id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.proforma_default_appearance"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documentLayouts, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.layoutCanBeModels
              ? [
                  _c("div", { staticClass: "mb-1 typographies-heading-h4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Apparence des modèles")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectLayoutModel",
                      staticClass: "mb-6 wp-10",
                      attrs: {
                        popperClass: "customDropdownCatRatePopupManager"
                      },
                      model: {
                        value: _vm.tempRateCategory.default_layouts.models.id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tempRateCategory.default_layouts.models,
                            "id",
                            $$v
                          )
                        },
                        expression: "tempRateCategory.default_layouts.models.id"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: null,
                          label: _vm.$t.__(
                            "settings.taxes.popup.CatRatePopupManager.template_default_appaearance"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documentLayouts, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3 typographies-heading-h3" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Gestion des tarifs")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-column" }, [
              _c(
                "div",
                { staticClass: "flex-row ai-center mb-1" },
                [
                  _c(
                    "el-radio",
                    {
                      ref: "radioValue",
                      staticClass: "m-0 flex-row ai-center",
                      attrs: { label: "value" },
                      model: {
                        value: _vm.tempRateCategory.price.type,
                        callback: function($$v) {
                          _vm.$set(_vm.tempRateCategory.price, "type", $$v)
                        },
                        expression: "tempRateCategory.price.type"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$l10n.__("Appliquer un montant par produit")
                            ) +
                            "\n                        "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tarifsManagerRadio1" } }, [
                _c(
                  "p",
                  {
                    staticClass: "gray-80 typographies-paragraph-small-regular",
                    attrs: { id: "subInfoTarifsManagerRadio" }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Si aucun montant n’a été spécifié, le montant de référence du produit sera appliqué"
                          )
                        ) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-row ai-center" },
              [
                _c(
                  "el-radio",
                  {
                    ref: "radioPercent",
                    staticClass: "m-0 flex-row ai-center",
                    attrs: { name: "tarifsManagerRadio", label: "percent" },
                    model: {
                      value: _vm.tempRateCategory.price.type,
                      callback: function($$v) {
                        _vm.$set(_vm.tempRateCategory.price, "type", $$v)
                      },
                      expression: "tempRateCategory.price.type"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Appliquer un pourcentage du prix de référence du produit"
                            )
                          ) +
                          "\n                    "
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.tempRateCategory.price.type === "percent"
              ? [
                  _c(
                    "div",
                    { staticClass: "mb-1 mt-2 typographies-heading-h4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$l10n.__("Pourcentage à appliquer")) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-input",
                    {
                      staticClass: "rate_input_percent",
                      attrs: { max: "500", min: "-500" },
                      on: { change: _vm.onPriceValueChange },
                      model: {
                        value: _vm.tempRateCategory.price.value,
                        callback: function($$v) {
                          _vm.$set(_vm.tempRateCategory.price, "value", $$v)
                        },
                        expression: "tempRateCategory.price.value"
                      }
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                  _vm._v(" "),
                  _vm.displayErrorOnInputValue
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "pt-1 typographies-paragraph-small-regular alert-red"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Merci de rentrer une valeur valide (pas plus de deux décimales)"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-3",
              attrs: {
                disabled: _vm.cantSubmit,
                label: _vm.$t.__("common.actions.save")
              },
              on: { click: _vm.onSubmitForm }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.loading } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }